const storageKeys = {
  DeviceId: 'deviceId',
  Token: 'token',
  RefreshToken: 'refreshToken',
  Username: 'username',
};

export class LocalStorageService {
  static setDeviceId(deviceId: string): void {
    localStorage.setItem(storageKeys.DeviceId, deviceId);
  }

  static setToken(token: string): void {
    localStorage.setItem(storageKeys.Token, token);
  }

  static setRefreshToken(refreshToken: string): void {
    localStorage.setItem(storageKeys.RefreshToken, refreshToken);
  }

  static setUsername(username: string): void {
    localStorage.setItem(storageKeys.Username, username);
  }

  static getDeviceId(): string | null {
    return localStorage.getItem(storageKeys.DeviceId);
  }

  static getToken(): string | null {
    return localStorage.getItem(storageKeys.Token);
  }

  static getRefreshToken(): string | null {
    return localStorage.getItem(storageKeys.RefreshToken);
  }

  static getUsername(): string | null {
    return localStorage.getItem(storageKeys.Username);
  }

  static clearDeviceId(): void {
    localStorage.removeItem(storageKeys.DeviceId);
  }

  static clearToken(): void {
    localStorage.removeItem(storageKeys.Token);
    localStorage.removeItem(storageKeys.RefreshToken);
  }

  static clearUsername(): void {
    localStorage.removeItem(storageKeys.Username);
  }
}
